var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInbound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "107px",
    height: "33px",
    viewBox: "0 0 107 33",
    enableBackground: "new 0 0 107 33",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M2.9,17H1.3c-0.1,0-0.1,0.1-0.1,0.1v14.5c0,0.1,0.1,0.1,0.1,0.1h1.6C3,31.7,3,31.7,3,31.6V17.1 C3,17,3,17,2.9,17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M34.5,24.1c1.3-0.7,2-1.9,2-3.3c0-2.3-1.9-3.8-4.9-3.8h-6.2c-0.1,0-0.1,0.1-0.1,0.1v14.5 c0,0.1,0.1,0.1,0.1,0.1h6.4c3.3,0,5.4-1.6,5.4-4.1C37.3,25.9,36.4,24.7,34.5,24.1z M27.3,23.4v-4.7h4.3c1.9,0,3.1,0.8,3.1,2.2 c0,1.5-1.2,2.5-3.2,2.5H27.3z M35.4,27.5c0,1.5-1.3,2.5-3.4,2.5h-4.7v-4.8h4.4C34.1,25.1,35.4,26,35.4,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M75.8,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M71.9,17h-1.6c-0.1,0-0.1,0.1-0.1,0.1v8.4c0,2.9-1.5,4.6-4.2,4.6c-2.7,0-4.3-1.7-4.3-4.7v-8.3 c0-0.1-0.1-0.1-0.1-0.1h-1.6c-0.1,0-0.1,0.1-0.1,0.1v8.4c0,4,2.3,6.4,6.2,6.4c3.9,0,6.2-2.5,6.2-6.6v-8.3C72,17,72,17,71.9,17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M93.1,17.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89,17h-1.6c-0.1,0-0.1,0.1-0.1,0.1v11.2L78.4,17c0,0-0.1-0.1-0.1-0.1h-1.5c-0.1,0-0.1,0.1-0.1,0.1v14.5 c0,0.1,0.1,0.1,0.1,0.1h1.6c0.1,0,0.1-0.1,0.1-0.1V20.1l9.1,11.5c0,0,0.1,0.1,0.1,0.1H89c0.1,0,0.1-0.1,0.1-0.1V17.1 C89.2,17,89.1,17,89,17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20.3,17h-1.6c-0.1,0-0.1,0.1-0.1,0.1v11.2L9.7,17c0,0-0.1-0.1-0.1-0.1H8.1C8,17,7.9,17,7.9,17.1v14.5 c0,0.1,0.1,0.1,0.1,0.1h1.6c0.1,0,0.1-0.1,0.1-0.1V20.1l9.1,11.5c0,0,0.1,0.1,0.1,0.1h1.3c0.1,0,0.1-0.1,0.1-0.1V17.1 C20.5,17,20.4,17,20.3,17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.8,26.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M107,23.7c-0.3-4-3.5-6.8-7.8-6.8h-5C94.1,17,94,17,94,17.1v14.5c0,0.1,0.1,0.1,0.1,0.1h5 c4.3,0,7.5-2.8,7.8-6.8C107,24.9,107,24.2,107,23.7z M105,24.4c0,3.3-2.4,5.6-5.8,5.6h-3.2V18.8h3.2C102.6,18.8,105,21.1,105,24.4 z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 41,
    cy: 29.2,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 0.5,
    cy: 16.1,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 106.4,
    cy: 29.3,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 55.1,
    cy: 19.6,
    r: 0.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M32.1,29.2H28c-0.1,0-0.1-0.1-0.1-0.1v-1.4c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v1.3h4 c0.3,0,0.9,0,1.4-0.2c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2C33.1,29.2,32.5,29.2,32.1,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M31.8,22.7c-0.1,0-0.2,0-0.2,0H28c-0.1,0-0.1-0.1-0.1-0.1v-1.6c0-0.1,0.1-0.1,0.1-0.1 c0.1,0,0.1,0.1,0.1,0.1v1.4h3.4c0.3,0,0.6,0,0.8,0c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2C32.2,22.7,32,22.7,31.8,22.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.2,27.6c-0.1,0-0.1-0.1-0.1-0.1c0-0.4-0.1-0.8-0.2-1.2c-0.3-0.9-0.9-1.7-1.8-2.3c0,0-0.1-0.1-0.1-0.1 c0,0,0-0.1,0-0.1c0.8-0.8,1.2-1.9,1.2-3.1c0-2.7-2.2-4.5-5.6-4.5h-6.2c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1h6.2 c3.5,0,5.9,1.9,5.9,4.8c0,1.2-0.4,2.3-1.2,3.2c0.9,0.6,1.5,1.4,1.8,2.3c0.1,0.4,0.2,0.8,0.2,1.3C38.4,27.6,38.3,27.6,38.2,27.6 C38.2,27.6,38.2,27.6,38.2,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M21.4,31.7c-0.1,0-0.1-0.1-0.1-0.1V16.2h-2.5c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1h2.7 c0.1,0,0.1,0.1,0.1,0.1v15.5C21.6,31.7,21.5,31.7,21.4,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M17.8,25.9c0,0-0.1,0-0.1-0.1l-7.5-9.6H8c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1h2.2 c0,0,0.1,0,0.1,0.1l7.6,9.6C17.9,25.7,17.9,25.8,17.8,25.9C17.8,25.8,17.8,25.9,17.8,25.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M3.9,31.7c-0.1,0-0.1-0.1-0.1-0.1V16.2H1.7c-0.1,0-0.1-0.1-0.1-0.1c0-0.1,0.1-0.1,0.1-0.1h2.3 c0.1,0,0.1,0.1,0.1,0.1v15.5C4.1,31.7,4,31.7,3.9,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M48.2,33c-2.5,0-4.8-1-6.4-2.8c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0c1.5,1.7,3.7,2.7,6.1,2.7 c4.6,0,8.3-3.7,8.3-8.4c0-0.8-0.1-1.7-0.3-2.5c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0.1c0.2,0.8,0.3,1.7,0.3,2.5 C56.8,29.2,53,33,48.2,33z M48.2,29.4c-2.7,0-4.8-2.2-4.8-5.1c0-2.9,2.1-5.1,4.8-5.1c2.2,0,4.1,1.4,4.6,3.7c0,0.1,0,0.2-0.1,0.2 c-0.1,0-0.2,0-0.2-0.1c-0.5-2.1-2.3-3.4-4.3-3.4c-2.6,0-4.5,2.1-4.5,4.8c0,2.7,1.9,4.8,4.5,4.8c0.1,0,0.1,0.1,0.1,0.1 C48.3,29.3,48.2,29.4,48.2,29.4z M40.1,26.7c-0.1,0-0.1,0-0.1-0.1c-0.1-0.4-0.2-0.9-0.2-1.3c0-0.3,0-0.6,0-1 c0-4.9,3.8-8.7,8.6-8.7c2.4,0,4.6,0.9,6.2,2.5c0.1,0.1,0.1,0.2,0,0.2c-0.1,0.1-0.2,0.1-0.2,0c-1.5-1.6-3.6-2.5-6-2.5 c-4.6,0-8.3,3.7-8.3,8.4c0,0.3,0,0.6,0,0.9c0,0.4,0.1,0.9,0.2,1.3C40.2,26.6,40.2,26.7,40.1,26.7C40.1,26.7,40.1,26.7,40.1,26.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65.9,33c-4.4,0-7.2-2.9-7.2-7.5v-5c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v5 c0,4.4,2.6,7.2,6.9,7.2c2.1,0,3.9-0.7,5.1-2c0.1-0.1,0.1-0.1,0.2,0c0.1,0.1,0.1,0.1,0,0.2C69.9,32.3,68,33,65.9,33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M89,32.8h-1.8c0,0-0.1,0-0.1-0.1l-7.8-9.9c-0.1-0.1,0-0.2,0-0.2c0.1-0.1,0.2,0,0.2,0l7.8,9.9H89 c0.1,0,0.1,0.1,0.1,0.1C89.2,32.7,89.1,32.8,89,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M78.4,32.8h-2.5c-0.1,0-0.1-0.1-0.1-0.1V17.2c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v15.3h2.4 c0.1,0,0.1,0.1,0.1,0.1C78.5,32.7,78.4,32.8,78.4,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.2,32.8h-6.1c-0.1,0-0.1-0.1-0.1-0.1V17.2c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v15.3h5.9 c2.5,0,4.8-0.9,6.3-2.5c0.1-0.1,0.2-0.1,0.2,0c0.1,0.1,0.1,0.2,0,0.2C104.1,31.8,101.7,32.8,99.2,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M56.2,21.9c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l2.6-1.2c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2 L56.2,21.9C56.3,21.9,56.3,21.9,56.2,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M38.3,27.6c-0.1,0-0.1,0-0.1-0.1c0-0.1,0-0.2,0.1-0.2l1.8-0.9c0.1,0,0.2,0,0.2,0.1c0,0.1,0,0.2-0.1,0.2 L38.3,27.6C38.3,27.6,38.3,27.6,38.3,27.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M104.1,24.5c-0.1,0-0.1-0.1-0.1-0.1c0-2.7-2-4.6-4.8-4.6h-2.4c-0.1,0-0.1-0.1-0.1-0.1s0.1-0.1,0.1-0.1 h2.4c3,0,5.1,2,5.1,4.9C104.3,24.4,104.2,24.5,104.1,24.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M65.8,29.3c-1.2,0-2.1-0.4-2.7-1.1c0-0.1,0-0.2,0-0.2c0.1,0,0.2,0,0.2,0c0.5,0.7,1.4,1,2.5,1 c1.5,0,3.2-0.6,3.2-3.7v-8.1c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v8.1C69.4,28.6,67.5,29.3,65.8,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.4,26.1c-0.1,0-0.1-0.1-0.1-0.1v-8.8c0-0.1,0.1-0.1,0.1-0.1s0.1,0.1,0.1,0.1V26 C86.6,26,86.5,26.1,86.4,26.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M10.8,31.7c-0.1,0-0.1-0.1-0.1-0.1v-8.8c0-0.1,0.1-0.1,0.1-0.1c0.1,0,0.1,0.1,0.1,0.1v8.8 C10.9,31.7,10.9,31.7,10.8,31.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M54.9,20.9c0,0-0.1-0.1-0.1-0.1c-0.6-0.1-1-0.6-1-1.2c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0-0.1 c-1.4-1.6-3.4-2.5-5.6-2.5c-4.2,0-7.5,3.4-7.5,7.6c0,1.2,0.3,2.4,0.8,3.5c0,0,0,0.1,0.1,0.1c0.5,0.2,0.8,0.6,0.8,1.1 c0,0,0,0.1,0,0.1l0,0c0,0,0,0.1,0,0.1c1.4,1.7,3.5,2.7,5.8,2.7c4.2,0,7.5-3.4,7.5-7.6C55.7,23.1,55.5,21.9,54.9,20.9z M48.2,30.2 c-3.2,0-5.6-2.5-5.6-5.8c0-3.3,2.4-5.8,5.5-5.8c3.2,0,5.6,2.5,5.6,5.8C53.7,27.7,51.4,30.2,48.2,30.2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInbound);
export default __webpack_public_path__ + "static/media/inbound.7d90170f8cba0d87e310012b14c5d784.svg";
export { ForwardRef as ReactComponent };